import React from 'react'
import { Route } from 'react-router-dom'
import MainEmail from '../Views/Web/E-Mail/MainEmail'
import MainEmailsent from '../Views/Web/E-Mail/EmailSent/MainEmailsent'
import EmailSentIndex from '../Views/Web/E-Mail/EmailSent/EmailSentIndex'
import CreateEmailSent from '../Views/Web/E-Mail/EmailSent/CreateEmailSent'
import EditEmailSent from '../Views/Web/E-Mail/EmailSent/EditEmailSent'
import ViewEmailSent from '../Views/Web/E-Mail/EmailSent/ViewEmailSent'

function EmailRoutes() {
    return (
      <Route path="email" element={<MainEmail />}>
          <Route path="email-sent" element={<MainEmailsent/>} >
           <Route index element={<EmailSentIndex/>} />
           <Route path='create' element={<CreateEmailSent/>} />
           <Route path='edit/:emailEditId' element={<EditEmailSent/>} />
           <Route path='view/:emailViewId' element={<ViewEmailSent/>} />
          </Route>
          
      </Route>
    )
  }
  
  export default EmailRoutes